<template>
  <div class="d-flex flex-column align-items-center" :style="{ backgroundColor: brandConfig.backgroundColor || 'black' }">
    <div class="col-12 col-sm-8 col-md-6 col-lg-5 col-xl-3 vue-container">
      <router-view/>
    </div>
  </div>
</template>

<script>
import {setBrandConfig} from "@/functions/setBrandConfig";
import {mapState} from "vuex";
import addGTM from "@/functions/addGTM";

export default {
  computed: {
    ...mapState(['brandConfig'])
  },
  async beforeMount() {
    setBrandConfig();
    this.setTabName()
    this.setFavicon()
    if (this.brandConfig.gtmIdentifier) addGTM(this.brandConfig.gtmIdentifier);
  },
  methods: {
    setTabName() {
      document.title = this.brandConfig.tabTitle;
    },
    setFavicon() {
      this.$nextTick(() => {
        const assetBrand = this.brandConfig.assetBrand || this.brandConfig.brand;
        const faviconPath = require(`@/brand/${assetBrand}/assets/logo.png`);

        const link = document.querySelector("link[rel~='icon']") || document.createElement('link');
        link.rel = 'icon';
        link.type = 'image/png';
        link.href = faviconPath;

        if (!link.parentNode) {
          document.head.appendChild(link);
        }
      });
    },
  }
}
</script>

<style>
</style>
